import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectOutput',
  props: {
    input: null,
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var name = computed(function () {
      var _props$input;
      return (_props$input = props.input) === null || _props$input === void 0 || (_props$input = _props$input.project) === null || _props$input === void 0 ? void 0 : _props$input.name;
    });
    return {
      __sfc: true,
      props: props,
      name: name
    };
  }
});